module.exports = __webpack_public_path__ + "img/brave2-min.jpg";